<div class="start-center flex">
    <span class="mat-headline-6 flex"> Default Installers </span>
    <button
        mat-raised-button
        (click)="newItemClicked()"
        color="primary"
        [disabled]="!mappedItem?.id"
    >
        Add New Default Installer
    </button>
</div>
<cb-table class="cb-margin-top" [loaded]="true" [stringColumns]="columns" [maxHeightOffset]="287">
    @for (result of searchResults; track result) {
        <tr cbTableRow>
            <cb-td-text [value]="result.tradeType?.path"></cb-td-text>
            <cb-td-text [value]="result.supplier?.label"></cb-td-text>
            <td cbTableStickyCol="end" cbTableShrinkCol>
                <button mat-icon-button (click)="editItemClickedAlternative(result)">
                    <mat-icon> edit </mat-icon>
                </button>
                <button class="cb-margin-left" mat-icon-button (click)="deleteClicked(result)">
                    <mat-icon> delete </mat-icon>
                </button>
            </td>
        </tr>
    }
</cb-table>
